import { BusinessReviewsScreen } from '@/screens/business/business-reviews-screen';
export default BusinessReviewsScreen;
